module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', [_c('transition', {
    attrs: {
      "name": "notifyFade"
    }
  }, [(!!_vm.notify) ? _c('div', {
    staticClass: "notify-message-parent"
  }, [_c('div', {
    staticClass: "notify-message"
  }, [_c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.notify.success, 'alert-danger': _vm.notify.danger, 'alert-warning': _vm.notify.warning
    }
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "href": "#",
      "data-dismiss": "alert",
      "aria-label": "close",
      "title": "close"
    }
  }, [_vm._v("×")]), _c('p', {
    staticClass: "notify-msg"
  }, [_vm._v(_vm._s(_vm.$t(_vm.notify.message_i18n)))])])])]) : _vm._e()])], 1), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-lg btn-menu",
    attrs: {
      "to": "/facilities?type=create_report"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Create Report')))])])], 1), _c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-lg btn-menu",
    attrs: {
      "to": "/plans/create"
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card"
  }), _c('p', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('Create Plan')))]), _c('p', {
    staticClass: "visible-xs"
  }, [_vm._v(_vm._s(_vm.$t('Create Plan xs')))])])], 1)])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-lg btn-menu",
    attrs: {
      "to": "/facilities?type=reports_history"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Report History')))])]), (0 < _vm.reportSendFails) ? _c('span', {
    staticClass: "alert-label summary"
  }, [_vm._v(_vm._s(_vm.$t('Send Error Count', {
    'Count': _vm.reportSendFails
  })))]) : _vm._e()], 1), _c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-lg btn-menu",
    attrs: {
      "to": "/monthly_check"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Monthly Check')))])])], 1)])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-info btn-lg btn-menu",
    attrs: {
      "to": "patients/list"
    }
  }, [_c('i', {
    staticClass: "fa fa-address-book-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Search Patients')))])])], 1), _c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "facilities?type=select_facility"
    }
  }, [_c('i', {
    staticClass: "fa fa-hospital-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Facility Clinic')))])])], 1)])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "/edit_shops"
    }
  }, [_c('i', {
    staticClass: "fa fa-medkit"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Shop Edit')))])])], 1), _c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "/phrases"
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Phrase')))])])], 1)])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-success btn-lg btn-menu",
    attrs: {
      "to": "/medicines"
    }
  }, [_c('i', {
    staticClass: "fa fa-flask"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Medicine')))])])], 1), _c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-menu",
    attrs: {
      "to": "/print"
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Print All')))])])], 1)])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-menu",
    attrs: {
      "to": "/send_pdf"
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Send PDF')))])])], 1), _c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-lg btn-menu",
    attrs: {
      "to": "/send_pdf_history"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('Send PDF History')))])])], 1)])]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 text-center col-menu"
  }, [_c('a', {
    staticClass: "btn btn-purple btn-lg btn-menu",
    on: {
      "click": function($event) {
        _vm.goSyainsoshiki()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _c('p', [_vm._v(_vm._s(_vm.$t('User Shop')))]), _c('div', {
    staticClass: "link-notes-frame"
  }, [_c('div', {
    staticClass: "link-notes up"
  }, [_vm._v(_vm._s(_vm.$t('Link Name')))]), _c('div', {
    staticClass: "link-notes"
  }, [_vm._v(_vm._s(_vm.$t('Link Notes')))])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fb373c3!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/home.pug
// module id = 370
// module chunks = 1